import { createSvgIcon } from '@automata/mui-theme';
export const CliniSafeYellowBinIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.7434 9.49464C44.5236 9.04296 45.4865 9.04629 46.2635 9.50337L70.7676 23.9175C71.5311 24.3667 72 25.1864 72 26.0723V73.9238C72 74.8159 71.5246 75.6404 70.7526 76.0874L52.7481 86.511C51.9793 86.9561 51.032 86.9598 50.2598 86.5207L25.7642 72.5919C24.9827 72.1475 24.5 71.3177 24.5 70.4186V22.0769C24.5 21.1848 24.9754 20.3603 25.7474 19.9134L43.7434 9.49464ZM44.994 12.2371L27.5 22.3652V70.1278L51.4933 83.771L69 73.6356V26.3583L44.994 12.2371Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.1362 21.4965C26.4145 21.0195 27.0268 20.8583 27.5039 21.1366L51.0068 34.8467L69.0064 24.6307C69.4867 24.3581 70.0971 24.5265 70.3697 25.0068C70.6423 25.4871 70.4739 26.0975 69.9936 26.3701L52 36.5827V84.5004C52 85.0527 51.5523 85.5004 51 85.5004C50.4477 85.5004 50 85.0527 50 84.5004V36.5748L26.4961 22.8642C26.0191 22.5859 25.8579 21.9736 26.1362 21.4965Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45 11.0004C45.5523 11.0004 46 11.4481 46 12.0004V32.0004C46 32.5527 45.5523 33.0004 45 33.0004C44.4477 33.0004 44 32.5527 44 32.0004V12.0004C44 11.4481 44.4477 11.0004 45 11.0004Z"
    />
  </svg>,
  'CliniSafeYellowBinIcon'
);
